import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "auto_follow"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_SelectShCompanies = _resolveComponent("SelectShCompanies")
  const _component_SelectShTopics = _resolveComponent("SelectShTopics")

  return ($data.loading)
    ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SelectShCompanies, {
          modelValue: $options.companies,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.companies) = $event))
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_SelectShTopics, {
          modelValue: $options.topics,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.topics) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ]))
}